"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePeopleTechFeatureGateService = void 0;
const react_query_1 = require("react-query");
const fetchClient_1 = require("../../client/fetchClient");
const paths_1 = require("../../paths");
const EventEmitter_1 = require("../../utils/EventEmitter");
const taaConfigs_1 = require("../../contexts/taaConfigs");
const fetchUtils_1 = require("../../client/fetchUtils");
function usePeopleTechFeatureGateService({ shouldFetch = false }) {
    const { clientName, currentStage } = (0, taaConfigs_1.useTaaConfigsContext)();
    const host = fetchUtils_1.essPortalUrl[currentStage];
    const ApiPath = (0, paths_1.GET_PEOPLE_TECH_FEATURE_GATE_SERVICE_API)();
    return (0, react_query_1.useQuery)(['peopleTechFeatureGateService', ApiPath], () => (0, fetchClient_1.getData)({
        path: ApiPath,
        host,
        eventName: EventEmitter_1.taaEvents.PEOPLE_TECH_FEATURE_GATE_SERVICE,
        metaData: {
            apiName: 'peopleTechFeatureGateService',
            clientName
        }
    }, currentStage), {
        enabled: shouldFetch,
        staleTime: 60 * 1000,
        retry: false
    });
}
exports.usePeopleTechFeatureGateService = usePeopleTechFeatureGateService;
